const PlayBehavior = require('../behaviors/PlayLottieBehavior');

module.exports = (target, data, el) => {
    if (!data) return target;

    target._playerBehavior = PlayBehavior(data, el);

    target._renderBehavior = null;
    target._resizeBehavior = null;

    return target;
};
